"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDeepEqual = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var isDeepEqual = function isDeepEqual(x, y) {
  return !!(x && y && (0, _typeof2.default)(x) === 'object' && (0, _typeof2.default)(y) === 'object' ? Object.keys(x).length === Object.keys(y).length && Object.keys(x).reduce(function (isEqual, key) {
    return isEqual && isDeepEqual(x[key], y[key]);
  }, true) : x === y);
};

exports.isDeepEqual = isDeepEqual;